export function handleDownloadByObjectUrl(downloadUrl: string): void {
  // open a popup window and set the url to the blob url
  const pdfWindow = window.open(downloadUrl);

  // if the popup window is blocked, the pdf will be opened via a link with target _blank
  if (!pdfWindow || pdfWindow.closed || typeof pdfWindow.closed === 'undefined') {
    const downloadLink = document.createElement('a');

    // set the href to the blob url and set target to _blank
    downloadLink.href = downloadUrl;
    downloadLink.target = '_blank';
    downloadLink.click();
    downloadLink.remove();
  }

  const delay = 600000; // 10min
  // DMP-12242: revoke the blob url to prevent further access and remove the link, but  delay the revokation a little (cf. FileSaver.js)
  // to support longer DL times and more browsers, we had issues in Chrome, see also:
  // https://stackoverflow.com/questions/63109880/blob-createobjecturl-download-not-working-in-chrome
  // and chromium bugs: https://bugs.chromium.org/p/chromium/issues/detail?id=910144 and underlying
  // base issue: https://bugs.chromium.org/p/chromium/issues/detail?id=158957 (open since 2012)
  window.setTimeout(() => URL.revokeObjectURL(downloadUrl), delay);
}
